import React from 'react'
import { graphql, Link } from "gatsby"

import { ChevronLeft } from 'react-feather'
import HtmlHead from '../utils/head'

import Layout from '../layouts/default'
import SEO from "../utils/seo"
import Time from "@ui-kit/atoms/label"
import Pill from '@ui-kit/atoms/button/pill'

import PageLayout from '../components/display/page'
import Prose from '@ui-kit/atoms/prose'
//import Share from "../components/share"


const Scene = ({ data: { node }, pageContext: { wysiwygFiles, wysiwygImages, wysiwygVideos} }) => {

    const iso = new Date(node.pubdate).toISOString();
    return (
            <Layout>

            <PageLayout>
                <aside>
                    <Link to={'/news'}><Pill inverted elem={'span'}><ChevronLeft />News</Pill></Link>
                    <dl>
                        <dt><Time captitalise elem="time" dateTime={iso}>{new Intl.DateTimeFormat('en-GB', { dateStyle: 'long' }).format(new Date(node.pubdate))}</Time></dt>
                        <dd>
                            <ul>
                                <li><Pill silver elem="span">{node.relationships.tag.name}</Pill></li>
                            </ul>
                        </dd>
                    </dl>
                </aside>
                {node.body ? (
                    <article itemScope itemType="http://schema.org/NewsArticle">
                        <h1 itemProp="headline">{node.title}</h1>
                        <Prose
                            env={process.env.GATSBY_SITE}
                            wysiwygFiles={wysiwygFiles}
                            wysiwygImages={wysiwygImages}
                            wysiwygVideos={wysiwygVideos}
                            className="prose"
                            itemProp={'articleBody'}
                            html={node.body.html}
                            />
                    </article>
                ): null}
                </PageLayout>
        </Layout>
    )
}

export default Scene


export function Head({ data: { node}, ...props }) {

    return (
      <HtmlHead {...node} />
    )
  }

export const query = graphql`
    query BlogPost($nid: Int!) {
        node:nodeArticle(drupal_internal__nid: {eq: $nid }) {
            nid:drupal_internal__nid
            title
            pubdate:field_issue_date
            path {
                alias
            }
            body {
                html:value
            }
            relationships {
                tag:field_article_type {
                    name
                }
            }
        }
    }

`